import { createContext } from 'react';
import { Organization, ModuleName } from '@/types';

export interface TenantContextType {
  currentOrganization: Organization | null;
  /** Nombre del negocio (salons.name). Usar en UI en lugar de org name. */
  businessName: string | null;
  activeModules: ModuleName[];
  hasModule: (module: string) => boolean;
  isLoading: boolean;
  refreshTenant: () => void;
}

export const TenantContext = createContext<TenantContextType | undefined>(undefined);
